import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { routing } from './ib-mam-routing.module';
import { IbMamComponent } from './ib-mam.component';
import { MamMasterComponent } from './mam-master/mam-master.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IbMamService } from './ib-mam.service';
import { MamFollowerComponent } from './mam-follower/mam-follower.component';

@NgModule({
  declarations: [IbMamComponent, MamMasterComponent, MamFollowerComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    routing,
  ],
  providers: [IbMamService],
})
export class IbMamModule {}
